import React from "react";
import LegalLayout from "../../layouts/LegalLayout/LegalLayout";
import styles from "./Legal.module.scss";

const CardTermsUS = () => {
  return (
    <LegalLayout title="STBL CARD TERMS (U.S.)">
      <div className={styles.legalContent}>
        <section className={styles.section}>
          <h2>
            STBL CREDIT CARD ACCOUNT OPENING DISCLOSURES – SET CREDIT LIMIT
          </h2>

          <h3>INTEREST RATE AND INTEREST CHARGES</h3>
          <table className={styles.disclosureTable}>
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.labelCell}>
                  Annual Percentage Rate (APR) for Purchases
                </td>
                <td>0.00%</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>APR for Balance Transfers</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>APR for Cash Advances</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Paying Interest</td>
                <td>
                  You will not be charged interest on purchases. Your due date
                  for payment of amounts owed on your Card is 21 days after the
                  close of each billing cycle.
                </td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Minimum Interest Charge</td>
                <td>There is no interest chargeable to this Credit Card.</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>
                  For Credit Card Tips from the Consumer Financial Protection
                  Bureau
                </td>
                <td>
                  To learn more about factors to consider when applying for or
                  using a credit card, visit the website of the Consumer
                  Financial Protection Bureau at:{" "}
                  <a
                    href="http://www.consumerfinance.gov/learnmore"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    http://www.consumerfinance.gov/learnmore
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <h3>FEES</h3>
          <h4>Annual Fees</h4>
          <table className={styles.disclosureTable}>
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.labelCell}>Annual Fee</td>
                <td>None</td>
              </tr>
            </tbody>
          </table>

          <h4>Transaction Fees</h4>
          <table className={styles.disclosureTable}>
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.labelCell}>Balance Transfer</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Cash Advance</td>
                <td>None</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>International Transaction</td>
                <td>1% of each transaction in U.S. dollars.</td>
              </tr>
            </tbody>
          </table>

          <h4>Penalty Fees</h4>
          <table className={styles.disclosureTable}>
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.labelCell}>Late Payment</td>
                <td>2% of the current outstanding card balance</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Over the Credit Line</td>
                <td>None</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Returned Payment</td>
                <td>Up to $29</td>
              </tr>
            </tbody>
          </table>

          <p>
            <strong>How We Will Calculate Your Balance:</strong> We use a method
            called &ldquo;average daily balance&rdquo;. See your Cardholder
            Agreement for more details.
          </p>
          <p>
            <strong>Billing Rights:</strong> Information on your rights to
            dispute transactions and how to exercise those rights is provided in
            your Card Regulations.
          </p>

          <div className={styles.mlaDisclosure}>
            <h4>Military Lending Act Disclosure</h4>
            <p>
              The following disclosure applies to persons covered by the
              Military Lending Act – other governmental programs and laws may
              also govern or apply to this transaction but are not described in
              the following disclosure. The following disclosure is required by
              the Military Lending Act. Federal law provides important
              protections to members of the Armed Forces and their dependents
              relating to extensions of consumer credit. In general, the cost of
              consumer credit to a member of the Armed Forces and his or her
              dependent may not exceed an annual percentage rate of 36 percent.
              This rate must include, as applicable to the credit transaction or
              account: the costs associated with credit insurance premiums; fees
              for ancillary products sold in connection with the credit
              transaction; any application fee charged (other than certain
              application fees for specified credit transactions or accounts);
              and any participation fee charged (other than certain
              participation fees for a credit card account). To learn if you are
              covered by the Military Lending Act or about the applicable rate,
              call us at +1 (385) 600-7758. The Arbitration and Class Waiver
              sections of your Agreement will not apply to you if you are
              covered by the Military Lending Act nor do any provisions of the
              Agreement that waive any right to legal recourse under any state
              or federal law to the extent required by the Military Lending Act.
            </p>
          </div>
        </section>

        <div className={styles.divider} />

        <section className={styles.section}>
          <h2>STBL CARDHOLDER AGREEMENT – SET LINE OF CREDIT</h2>
          <p className={styles.lastUpdated}>Last Updated: 9/15/2026</p>

          <div className={styles.importantNote}>
            <p>
              <strong>Arbitration Clause; Notices:</strong> PLEASE REVIEW THE
              ARBITRATION CLAUSE AND NOTICES SET FORTH BELOW IN THE SECTION
              TITLED DISPUTE RESOLUTION AND ARBITRATION. BY USING THE STBL CARD,
              YOU ARE AGREEING TO THE ARBITRATION CLAUSE AND NOTICES SET FORTH
              IN THAT SECTION. THE ARBITRATION CLAUSE WILL HAVE A SUBSTANTIAL
              EFFECT ON YOUR RIGHTS IN THE EVENT OF A DISPUTE, INCLUDING YOUR
              RIGHT TO BRING OR PARTICIPATE IN A CLASS PROCEEDING.
            </p>
          </div>

          <p>
            This STBL Cardholder Agreement (&ldquo;Agreement&rdquo;) is a
            binding agreement between you (&ldquo;you&rdquo; or
            &ldquo;your&rdquo;) and the Issuer (&ldquo;we&rdquo;,
            &ldquo;us,&rdquo; or &ldquo;our&rdquo;) that governs your use of the
            card account (&ldquo;Account&rdquo;) and STBL card (&ldquo;STBL
            Card&rdquo; or &ldquo;Card&rdquo;). The STBL Card is provided to you
            on behalf of STBL in connection with your status as STBL customer
            and pursuant to your separate User Agreement between you and STBL
            (the &ldquo;User Terms&rdquo;). We are not a party to the User Terms
            and disclaim any liability for the performance of services covered
            therein. In the event of any conflict between this Agreement and the
            User Terms, this Agreement shall be controlling.
          </p>

          <h3>Additional Definitions</h3>
          <p>
            The term &ldquo;Card&rdquo; means any card we issue associated with
            your Account, including renewal and substitute cards. The term
            &ldquo;Card&rdquo; also means any other access device that allows
            you to obtain Account credit from us, including your Account number.
            Other capitalized terms that are not defined here are generally
            defined the first time we use those terms. The term
            &ldquo;Issuer&rdquo; refers to Third National, including its
            affiliates, successors, and assigns. The term &ldquo;Supported
            Blockchain&rdquo; means the Ethereum Blockchain, Polygon Blockchain,
            Optimism Blockchain, Arbitrum Blockchain and other blockchain
            networks. We may update this list of Supported Blockchains at any
            time and at our sole discretion.
          </p>
          <p>
            The terms &ldquo;you&rdquo; and &ldquo;your&rdquo; mean each and all
            of the persons who are granted, accept or use the Account and any
            person who has guaranteed payment of the Account.
          </p>

          <h3>Overview of Account Agreement</h3>
          <p>
            We reserve the right to amend this Agreement or impose additional
            obligations or restrictions on you at any time with or without
            notice to you, except where required by applicable law. By
            continuing to use the Cards, you agree to be bound by such
            amendments or additional obligations or restrictions. We will notify
            you of any amendment to this Agreement by email. If any amendment to
            this Agreement allows you to reject such amendment, and if you
            reject the amendment in the manner described in such amendment, we
            may terminate your Account. If an amendment to this Agreement
            increases the applicable Interest Charges applicable to your Account,
            any existing unpaid balances may be subject to such increase to the
            Interest Charges.
          </p>
          <p>
            You agree that this Agreement becomes effective the first time you
            use any Card or the Account. You agree that you were not solicited
            for this product. You also agree that we may keep and use an image
            or copy of the Agreement to enforce its terms against you. When the
            Agreement states we &ldquo;may&rdquo; take an action, it means we
            are authorized to take that action in our sole discretion, subject
            only to any limitations or requirements established by law and the
            express terms of the Agreement. Please read this Agreement carefully
            and keep them for future reference. We may make new offers to you in
            the future or forward offers from others that may interest you. If
            these offers have new or different terms, those terms will be
            provided with the offer. If you accept the offer, the previously
            disclosed terms in the Agreement will still apply, except as
            modified by the offer.
          </p>
          <p>
            STBL provides technology services in connection with the STBL Card,
            and is not a bank, credit union, or money services business and does
            not itself extend credit, set interest rates, determine repayment
            terms or hold Collateral. Nothing in this Agreement shall be
            construed as creating a lender-borrower relationship between you and
            STBL.
          </p>
          <p>You acknowledge and agree that STBL:</p>
          <ul>
            <li>
              (i) is an express third-party beneficiary of this Agreement, with
              the limited right to enforce obligations that directly relate to
              its role;
            </li>
            <li>
              (ii) is not responsible for any decisions by the Issuer to
              approve, decline, suspend or close your Card account. STBL may, at
              the request of the Issuer, the payment network or a regulatory
              authority, suspend or restrict your access to the STBL platform or
              certain features, to protect against fraud, comply with applicable
              laws or manage program risk;
            </li>
            <li>
              (iii) does not control and is not responsible for the operation,
              security, or performance of the smart contracts used to hold your
              Collateral; and
            </li>
            <li>
              (iv) is not responsible for merchant acceptance of your STBL Card
              or for resolving disputes about goods or services purchased with
              the STBL Card.
            </li>
          </ul>

          <h3>Account Information We Need</h3>
          <p>
            We need and will request complete, current and valid information
            about you to manage your Account. Such information may include but
            is not limited to: your legal name; your address(es); your telephone
            number(s); your date(s) of birth; your employment and income
            information; and your Social Security number(s); or other government
            identification number(s). You must tell us when this information
            changes, and, if we agree to issue additional Cards, you must notify
            us of any changes to this information for each additional
            cardholder. You may update your address as described on your most
            recent Statement, through the website we maintain for your Account,
            or by calling us at the telephone number shown on your most recent
            Statement or the back of your Card. We may require that you provide
            additional documents that are acceptable to us so that we can verify
            this information and any changes. We may restrict or close your
            Account if we are unable to verify your information or if you do not
            provide the additional information we request, at our sole
            discretion.
          </p>
          <p>
            TO HELP THE GOVERNMENT FIGHT THE FUNDING OF TERRORISM AND MONEY
            LAUNDERING ACTIVITIES, FEDERAL LAW REQUIRES US TO OBTAIN, VERIFY,
            AND RECORD INFORMATION THAT IDENTIFIES EACH PERSON WHO OPENS AN
            ACCOUNT. WHAT THESE MEANS FOR YOU: WHEN YOU OPEN AN ACCOUNT, WE WILL
            ASK FOR THE NAME, ADDRESS, EMPLOYER IDENTIFICATION NUMBER AND
            ORGANIZATIONAL DOCUMENTS OF THE ACCOUNT OWNER AND THE NAMES,
            ADDRESSES, DATES OF BIRTH, AND OTHER INFORMATION CONCERNING EACH
            PRINCIPAL OWNER THAT WILL ALLOW US TO IDENTIFY THE ACCOUNT OWNER AND
            ITS PRINCIPAL OWNERS. WE MAY ALSO ASK TO SEE A COPY OF EACH
            PRINCIPAL OWNERS&rsquo; DRIVER&rsquo;S LICENSES OR OTHER
            IDENTIFICATION DOCUMENTS.
          </p>

          <h3>Balance Categories of Your Account</h3>
          <p>
            &ldquo;Balance Categories&rdquo; are the different Account segments
            we may establish with unique pricing, grace periods or other terms.
            The Balance Categories of your Account may include Purchases, Cash
            Advances, and Special Offers. We reserve the right to decide which
            Balance Category applies for each Account transaction and our
            decision will be final.
          </p>
          <p>
            A &ldquo;Purchase&rdquo; means the property, rights, goods and
            services we allow you to purchase, rent, or otherwise obtain
            directly from merchants and vendors by using your Card.
          </p>
          <p>
            A &ldquo;Special Offer&rdquo; means transactions and balances that
            post to your Account, subject to unique pricing, grace periods, or
            other terms we disclose from time to time for promotional and other
            reasons. Our Special Offer disclosures, if any, will explain when
            any unpaid Special Offer balances may be transferred to and combined
            with a different Balance Category after any temporary rate period
            ends.
          </p>

          <h3>Your Promises To Us</h3>
          <p>
            You promise to do everything the Agreement requires of you, as long
            as your Account has a balance or remains open. Each of you and all
            of you promise, individually and together, to pay us all amounts due
            on your Account, now and in the future. This includes amounts where
            you did not sign a purchase slip or other documents for the
            transaction. If you use your Card number without presenting your
            actual Card (such as for mail, telephone or Internet purchases),
            these transactions will be treated as if you used the Card in
            person. The amounts due on your Account include all transactions in
            each Balance Category made by any of you, plus all Fees and all
            Interest Charges, as described in this Agreement. Your
            &ldquo;Interest Charges&rdquo; are the charges we add to your
            Account based on the Annual Percentage Rates we apply to your
            Account balances. Your &ldquo;Fees&rdquo; are the charges we add to
            your Account that are not based on the Annual Percentage Rates, if
            any. If you allow someone else to use your Card, you are responsible
            for all transactions made by that person and all associated Fees and
            Interest Charges. If you die, your promise to pay us will apply to
            your estate, as permitted by law.
          </p>

          <h3>Using Your Account and Card</h3>
          <p>
            You may use your Card and the Account for making Purchases and for
            obtaining any Special Offers that we may provide, as permitted by
            this Agreement and applicable law.
          </p>
          <p>
            You agree to sign the Card immediately after you receive it. The
            Card is valid during the dates shown on the front. The Card is our
            property and you agree to return it to us or destroy it, if we ask.
            You agree to take reasonable steps to prevent the unauthorized use
            of your Card and Account.
          </p>
          <p>
            We are not responsible to you if someone refuses to accept your Card
            for any reason. We may reject any transaction for any reason. We may
            limit the combined dollar amount or the total number of certain
            Account transactions allowed during a single day or other time
            periods. We may restrict or delay the availability of Account
            credit, to protect you and us against potential fraud, unauthorized
            transactions, Account misconduct or misuse, or for other risk
            management reasons. We will not be liable to you if this happens.
            Except as otherwise required by applicable law or regulation, we
            will not be responsible for merchandise or services purchased or
            leased through the use of any Card or the Account.
          </p>
          <p>
            You agree not to use, try to use, or permit use of the Card or
            Account for any Internet gambling transactions or any other
            transactions that are illegal or not permitted by us. Even if you
            do, you must still pay us for these transactions, and they remain
            subject to all other terms of our Agreement. You must reimburse us
            for all damages and expenses associated with these transactions. You
            acknowledge and agree that you have read and understood the{" "}
            <a
              href="https://legal.raincards.xyz/legal/prohibitions"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://legal.raincards.xyz/legal/prohibitions
            </a>{" "}
            and that you will not engage in any such activities when using the
            Services or the STBL Card.
          </p>
          <p>
            From time to time, Account services may be unavailable to you, due
            to circumstances beyond our control, such as system failures, fires,
            floods, natural disasters or other unpredictable events. When this
            happens, you may be unable to use your Card or obtain Account
            information. We will not be responsible or liable to you if this
            happens.
          </p>

          <h3>Using a PIN</h3>
          <p>
            We may give you a personal identification number (&ldquo;PIN&rdquo;).
            For security reasons, you may have to provide the PIN before you are
            able to complete some transactions using the Card. With a PIN, you
            may, if enabled by us, use your Card to obtain cash from certain
            automated teller machines (&ldquo;ATM&rdquo;) or make Purchases at
            certain merchant point-of-sale devices (&ldquo;POS&rdquo;). Where
            enabled, you may do these things if the ATM or POS requires entry of
            a PIN and displays the logo of the Payment Card Network on your
            Card. We will treat any allowed ATM transactions as Cash Advances
            and all POS transactions as Purchases. Keep your PIN secure and do
            not write it down, give it to anyone, or keep it with your Card. If
            you lose your Card or believe someone has gained unauthorized access
            to your PIN, you must contact us immediately.
          </p>

          <h3>Statements and Billing Cycles</h3>
          <p>
            The documents or information we provide after each Billing Cycle
            through your Statement will disclose important information about
            your Account, including your Account transactions, payments, Fees,
            Interest Charges, unpaid balances in each Balance Category, and
            payment requirements. The intervals of time between your regular
            Statements (each, a &ldquo;Billing Cycle&rdquo;) are generally equal
            (approximately 30 days), but may vary slightly in length. Your first
            Billing Cycle may be more or less than 30 days. You must pay any
            Minimum Interest Charge and any Fees due after your first Billing
            Cycle, even if it is for a period less than 30 days. Your Statements
            disclose the specific length of each Billing Cycle. Your Account
            will continue to have Billing Cycles, even if a Statement is not
            required after any Billing Cycle.
          </p>
          <p>
            We will send a single Statement to you for all Cards on your
            Account, except when we are not required or permitted by law to send
            a Statement. We will send a Statement at the end of each Billing
            Cycle when your Account has a debit or credit balance of more than
            $0.01, if we have charged any Interest Charges to your Account, or
            as otherwise required by law.
          </p>

          <h3>Disputed Transactions</h3>
          <p>
            You must promptly inspect each Statement you receive and tell us
            about any errors or questions you have, as described in the
            &ldquo;Billing Rights&rdquo; section of your Statement and this
            Agreement. If you do not notify us as provided in these disclosures,
            we may assume that all information in the Statement is correct. If
            you dispute a transaction made by you or someone else on your
            Account, and we later credit your Account for all or part of the
            disputed amount, you agree to:
          </p>
          <ul>
            <li>Give us all of your rights against that other person;</li>
            <li>
              Give us any merchandise or other purchases you received in
              connection with the disputed amount, if we ask;
            </li>
            <li>
              Not pursue any claim or reimbursement from the merchant and other
              person; and
            </li>
            <li>
              Help us pursue and obtain reimbursement from the merchant and that
              other person, by promptly returning documents with any signatures
              we may request and otherwise providing us with reasonable
              cooperation.
            </li>
          </ul>

          <h3>No Warranties</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW AND EXCEPT AS
            OTHERWISE PROVIDED IN THE &ldquo;BILLING RIGHTS&rdquo; SECTION OF
            YOUR STATEMENTS AND THIS AGREEMENT, WE EXPRESSLY DISCLAIM ALL
            WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
            NON-INFRINGEMENT, ACCURACY, RELIABILITY, AND ANY WARRANTIES ARISING
            FROM COURSE OF DEALING OR USAGE OF TRADE.
          </p>

          <h3>Lost or Stolen Cards; Unauthorized Use; Replacement Cards</h3>
          <p>
            <strong>For Consumers:</strong> You must take reasonable steps to
            prevent the unauthorized use of your Card and Account. If you notice
            the loss or theft of your Card, or a possible unauthorized use of
            your Card, you should write to us immediately at the address
            provided on your Statement or call us at the telephone number
            provided on your Statement. You will not be liable for any
            unauthorized use that occurs after you notify us. You may, however,
            be liable for unauthorized use that occurs before your notice to us.
            In any case, your liability will not exceed $50 (or any lesser
            amount required by law or as provided under the express terms of a
            benefit provided by a Payment Card Network). If we reimburse your
            Account for unauthorized charges made using your Card, you agree to
            help us investigate, pursue and obtain reimbursement from the
            wrongdoer. Your help includes giving us documents that we ask for
            and that are acceptable to us. Unless canceled, a Card will be valid
            through the expiration date which is printed on the Card. We may
            replace a Card at any time and we may continue to issue renewal or
            replacement Cards until you notify us to cancel the Account.
          </p>
          <p>
            You are responsible for canceling any lost, misused or stolen Cards
            or the Account that you suspect may have been the subject of fraud,
            unauthorized use or misuse, whether as a result of termination of
            employment or otherwise. You are responsible for retrieving the
            canceled Card and destroying it to prevent further use. You may also
            cancel a Card by calling our customer service center. All telephone
            communications by you to us must be made by calling our customer
            service center at +1 (385) 600-7758 as soon as the need arises. You
            understand that we will require a reasonable amount of time to act
            on any request made by telephone.
          </p>
          <p>
            You will not be liable for any unauthorized use of your Card after
            you notify us orally or in writing of the loss, theft, or possible
            unauthorized use and you meet the following conditions: (1) you have
            exercised reasonable care with the Card; (2) you have not reported
            two or more incidents of unauthorized Card use within the previous
            12 months; and (3) you have maintained your Account(s) in good
            standing. The foregoing liability limitation does not apply to ATM
            cash advance transactions. In any case, your maximum liability for
            unauthorized use of a Card will not exceed $50 and you will not be
            liable for any unauthorized use that occurs after you notify us (or
            our designee) at the address or telephone number above.
          </p>

          <h3>Credit Limits</h3>
          <p>
            The credit limit will be determined, in part, by the amount of
            available Collateral (as defined below). We may assign different
            credit limits for the different Balance Categories of your Account.
            For example, your credit limit for any Cash Advances or Special
            Offers may be lower than your credit limit for Purchases or the
            overall credit limit of your Account. We may raise, lower, restrict,
            or cancel your credit limit on any Balance Category or the Account
            at any time and for any reason, subject to any notices that are
            required by law. This will not affect your obligation to pay us. You
            are responsible for keeping track of your Account balances and
            available credit. You agree not to allow your Account to go over any
            credit limit. We may honor transactions above your credit limits,
            but, if we do, this will not increase your credit limit and you must
            pay us the full amount of these transactions. Provided you maintain
            sufficient collateral to cover a Purchase, STBL reserves the right
            to set a daily or monthly spending limit at their sole discretion.
            The limit could be temporary or permanent. We will tell you if we do
            this, but we won&rsquo;t always notify you in advance. Any limits
            set will also apply to Authorized Users. We may set and vary limits
            and restrictions on certain uses of the Card or certain
            transactions. For example, contactless purchases may have their own
            limits.
          </p>

          <h3>Interest Charges</h3>
          <p>
            We may charge Interest Charges to your Account as shown in the
            Agreement, including your Account Opening Disclosures and
            Statements. If we charge Interest Charges to your Account, we
            calculate the Interest Charges by applying a Daily Periodic Rate to
            an &ldquo;Average Daily Balance&rdquo; of each Balance Category in
            your Account.
          </p>
          <p>
            To get the &ldquo;Average Daily Balance,&rdquo; we take the
            beginning balance of your Account each day (including any previously
            billed and unpaid transactions, Interest Charges and Fees), add any
            new Fees and Account transactions (including Purchases, Special
            Offers, or debit adjustments), and then subtract any unbilled
            Interest Charges and any payments or credits. This gives us the
            &ldquo;Daily Balance&rdquo; in each Balance Category. Then, we add
            up all the Daily Balances in each Balance Category for the Billing
            Cycle and divide the total by the number of days in the Billing
            Cycle. This gives us the &ldquo;Average Daily Balance.&rdquo; Your
            Statements disclose the &ldquo;Average Daily Balance&rdquo; of each
            Balance Category as the &ldquo;Balance Subject To Interest
            Rate.&rdquo;
          </p>
          <p>
            Interest Charges begin to accrue from the earlier of the date of the
            transaction, the date the transaction is processed and first posts
            to your Account, or the first day of the Billing Cycle, except as
            prohibited by law or as otherwise described in the Agreement.
            Interest Charges accrue on each unpaid amount until it is paid in
            full. Billed and unpaid Interest Charges are added to the proper
            Balance Category of your Account.
          </p>
          <p>
            We will not assess Interest Charges during a Billing Cycle for any
            new Purchases made during that Billing Cycle, if you pay the
            previous month&rsquo;s New Balance in full by its payment due date
            or if your previous month&rsquo;s New Balance was zero or a credit
            amount. If you have been paying your Account in full with no
            Interest Charges applied to Purchases, and you do not pay the next
            New Balance of your Account in full, we will assess prorated
            Interest Charges on the unpaid balance of your Purchases, as
            permitted or required by law. There is no grace period on any new
            Purchase transaction when there is an unpaid balance from a previous
            Statement. A Special Offer transaction is not subject to a grace
            period, unless the terms we provided with the Special Offer
            expressly state that these transactions are subject to a grace
            period.
          </p>
          <p>
            To determine the &ldquo;Daily Periodic Rate&rdquo; that applies to
            each Balance Category, we divide the corresponding Annual Percentage
            Rates by the number of days in a year. The resulting Daily Periodic
            Rate is carried three places past the decimal point and the last
            digit is rounded. We calculate your total Interest Charges by
            multiplying the Average Daily Balance of each Balance Category by
            its Daily Periodic Rate and then multiplying the result by the
            number of days in the Billing Cycle. This calculation may vary
            slightly from the Interest Charges we actually charge after a
            Billing Cycle, due to the effects of rounding or as a result of any
            Minimum Interest Charge that applies.
          </p>
          <p>
            Your Account Opening Disclosures disclose the Daily Periodic Rates
            and the corresponding Annual Percentage Rates that apply to each
            Balance Category. Your Account Opening Disclosures disclose the
            Minimum Interest Charges that will be due if any Balance Category of
            your Account is subject to Interest Charges after a Billing Cycle.
            Your Account Opening Disclosures also disclose which Annual
            Percentage Rates and Daily Periodic Rates may vary from Billing
            Cycle to Billing Cycle, based on changes to a published index rate.
            These Account Opening Disclosures identify the index rate we use,
            and the different margins we add to the index rate to determine the
            variable Annual Percentage Rates.
          </p>

          <h3>Fees</h3>
          <p>
            You must pay the following Fees we charge to your Account, in the
            amounts shown on your Account Opening Disclosures, shown in this
            Agreement, or disclosed to you at the time you ask us to provide
            particular services to you or on your behalf.
          </p>
          <p>
            <strong>Annual Fee:</strong> We may charge you this Fee for making
            the Account available and issuing Cards to you. We will post and
            treat this Fee as a Purchase transaction.
          </p>
          <p>
            <strong>Late Payment Fee:</strong> We may charge you this Fee if we
            do not receive your payment in time to credit it by the due date
            shown on your Statement. We will post and treat this Fee as a
            Purchase transaction.
          </p>
          <p>
            <strong>Returned Payment Fee:</strong> We may charge you this Fee
            each time any payment you make to us is not paid by your financial
            institution for any reason, even if that institution later pays it.
            We will post and treat this Fee as a Purchase transaction.
          </p>
          <p>
            <strong>Copying Fee:</strong> We may charge you a Fee of $10.00 for
            each paper copy of a transaction document or a Statement you
            request, unless they are required to resolve a billing dispute. We
            will post and treat this Fee as a Purchase transaction.
          </p>
          <p>
            <strong>Fees for Faster Payment Services:</strong> We may make
            services available that allow you to make faster payments through a
            customer service representative using a telephone, the Internet or
            other payment system. We will describe the terms for using these
            services before you use them. You do not have to use these other
            payment services, and we may charge you a Fee for using them. If we
            do, we will tell you the amount of the Fee at the time you request
            the service. We are not responsible if a payment made using our
            payment services is rejected or not paid. Even if it is, we may
            still keep the Fee. We will post and treat these Fees as a Purchase
            transaction.
          </p>
          <p>
            <strong>Foreign Transaction Fee:</strong> We may charge you this Fee
            each time you make a transaction in a currency other than US Dollars
            or make a transaction in a country outside the United States. This
            Fee will post to the same Balance Category as the transaction (for
            example, as a Purchase), and be treated as other transactions that
            post to this Balance Category.
          </p>

          <h3>Transactions Made in Foreign Currencies</h3>
          <p>
            If you make a transaction in a foreign currency, the Payment Card
            Network will convert it into a U.S. dollar amount. The Payment Card
            Network will use its currency conversion procedures in effect when
            it processes the transaction. The conversion rate in effect on the
            processing date might differ from the rate in effect on the
            transaction or posting date. We do not currently adjust the currency
            exchange rate.
          </p>

          <h3>Making Payments</h3>
          <p>
            You are responsible for payment in full of all transactions and fees
            identified on your Statement at the end of each Billing Cycle. You
            make a payment to STBL through any means permitted by STBL as
            disclosed when you log into your Account. You agree to follow the
            payment requirements we disclose on Statements from time to time.
            You may pay all or any part of your outstanding Account balance
            early, without penalty.
          </p>
          <p>
            If your due date occurs on a day on which we do not receive
            payments, any payment received the next day that conforms to the
            above requirements will not be treated as late. Please allow at
            least five (5) days for postal delivery. Unless we or our agents
            specifically instruct you to remit payment in a different manner,
            payments received at any other location or in any other form may not
            be credited for up to five (5) days. This may cause you to be
            charged Late Payment Fees and additional Interest Charges.
          </p>
          <p>
            If you give your Account number or other Account information to
            someone else to make a payment for you, we may provide Account
            information to them and process their payment as if you made it. We
            may refuse to accept any payment made by someone else for your
            Account. If we accept a payment made by someone else for your
            Account, you will be responsible for the payment made, even if that
            payment is rejected or not paid.
          </p>

          <h3>Collateral and Security Agreement</h3>
          <p>
            This Account is a secured Account. Either your primary linked wallet
            or any additional wallets may provide the collateral that will
            secure the charges made by you on any Card (the
            &ldquo;Collateral&rdquo;). The Collateral must be in a wallet on a
            Supported Blockchain. By entering into this Agreement, you are
            furnishing and granting us a security interest in the Collateral, as
            well as any additions to, substitutions or renewals of the
            Collateral. No portion of the Collateral may be used by you to
            secure other loans.
          </p>
          <p>
            In addition to the Collateral serving as collateral for your
            obligations to us, you also authorize STBL to liquidate Collateral
            pursuant to this section in the event of a &ldquo;Liquidation
            Event.&rdquo; A &ldquo;Liquidation Event&rdquo; will occur at a
            period set by STBL, a) in accordance with the terms of any
            &ldquo;smart-contract&rdquo; or other electronic code pursuant to
            which one or more transactions will be triggered with respect to
            some or all of the Collateral; b) if you fail to make a payment of
            the full amount owed to STBL within 21 calendar days of the due date
            on your Statement provided to you; or c) the Market Value of your
            Collateral drops below the value of the existing charges on your
            STBL card(s) and you do not add additional collateral or reduce the
            value of the existing charges to less than the Market Value of your
            Collateral by making a payment. &ldquo;Market Value&rdquo; of the
            Collateral will be determined by STBL using the net redemption value
            provided by a centralized stablecoin issuer and/or the real time
            price posted on a reputable and recognized exchange or price
            aggregator, or by reference to a price oracle, subject to
            STBL&rsquo;s sole discretion. You agree to pay all transaction costs or
            &ldquo;gas&rdquo; fees relating to any Liquidation transaction and
            that all such costs or fees will be paid from your Collateral and
            will not be credited to your Account. You agree that the market
            value of your collateral is determined solely by STBL through the
            above methods. You further agree that the Market Value is determined
            at the time of a Liquidation Event and any change in or fluctuation
            in value of the collateral before or after a Liquidation Event will
            have no bearing on obligations owed to STBL.
          </p>
          <p>
            You, through one or more of your linked wallet or additional
            wallets, must ensure that the Collateral has Market Value in United
            States Dollars (&ldquo;USD&rdquo;) that is greater than or equal to
            the value of all unpaid charges to all of your Cards. For example,
            if you provide Collateral with a Market Value equal to $100 of value
            in USD, and that Market Value does not change, your spending limit
            will be equal to $100 USD. Once $100 USD has been charged to your
            Card, you will be required to either make a payment or to provide
            additional Collateral in order to be able to make any additional
            Charges. If, at any time, the Market Value of the Collateral is less
            than the value of all unpaid charges, we may require you to add to
            the Collateral or you may be subject to a Liquidation Event, at our
            sole discretion. If the Market Value of your collateral is subject
            to a liquidation event when the Market Value is below your existing
            charges, you still owe us any difference between the USD value of
            the charges, and the USD value of the collateral at the time of
            Liquidation.
          </p>
          <p>
            The Collateral will be owned by you at all times and held in your
            custody. You authorize STBL and its designees to liquidate the
            Collateral upon a Liquidation Event and use the amounts to satisfy
            your payment obligations owed to STBL. You agree that STBL will not
            be required to notify you prior to such liquidation and you
            acknowledge and agree that, because of the nature of the blockchain
            technology and smart contract infrastructure, STBL may not be in a
            position to stop a liquidation from occurring.
          </p>
          <p>
            To withdraw your Collateral, you must provide STBL at least (3)
            business days prior notice. You agree that any Collateral that has
            been provided to us within the (3) business days of your notice to
            us may be subject to liquidation notwithstanding your notice to us
            of your withdrawal of the prior Collateral. Your withdrawal of any
            Collateral will not terminate any outstanding payment obligations
            you may have on your Card.
          </p>
          <p>
            We will not, in any circumstance, be holding custody of your
            Collateral. STBL is not a custodian or owner of your Collateral. If
            a Liquidation Event occurs, only the amount required to repay your
            outstanding financial obligations to STBL will be liquidated from
            your Collateral. Any unencumbered Collateral balances shall remain
            freely accessible. You authorize and consent to STBL liquidating the
            Collateral upon a Liquidation Event through a third party or by
            other means in order to satisfy payment obligations owed by you to
            STBL, the Issuer or other third party, as applicable.
          </p>
          <p>
            You acknowledge and agree that the Supported Blockchains that we
            accept as Collateral, including any Supported Blockchains that
            consist of or include tokenized assets, are issued and managed by
            third parties, and are subject to their own terms, conditions, and
            risks. We and STBL make no representations or warranties regarding
            any Supported Blockchain, or any underlying collateral related to
            such Supported Blockchain, including but not limited to their value,
            liquidity, stability, yield, rewards, or any other attributes. We
            and STBL expressly disclaim all responsibility and liability for any
            losses, fluctuations, or other outcomes arising from the ownership,
            use, performance, or characteristics of any Supported Blockchain
            and/or Collateral. You are responsible for evaluating and accepting
            the risks associated with any Supported Blockchain you choose to use
            as Collateral.
          </p>
          <p>
            You waive any right to require us to: (a) proceed against any
            Cardholder or any other person; (b) proceed against or exhaust any
            security held under this Agreement; or (c) pursue any other remedy
            available to us under applicable law. Issuer or STBL, without prior
            notice, and from time to time, may: (a) renew, compromise, extend,
            accelerate or otherwise change the terms relating to the Account;
            (b) take and hold security (other than the Collateral) for payment
            of the Account and enforce, exchange and release the security in any
            manner that we determine is proper; (c) release or substitute any
            Cardholder, guarantor, or endorser of the Account; and (d) increase
            or lower the Credit Limit on your Account, and no such action shall
            change the fact that the Collateral shall at all times serve as
            security for the Account.
          </p>

          <h3>Payment Processing</h3>
          <p>
            We may accept and process payments without losing any of our rights.
            Even if we credit your payment to your Account, we may delay the
            availability of Account credit until we confirm that your payment
            has cleared. We may resubmit and electronically collect returned
            payments. We may also adjust your Account as necessary to correct
            errors, to process returned and reversed payments, and to handle
            similar issues.
          </p>
          <p>
            An &ldquo;Item&rdquo; means a check, draft, money order or other
            negotiable instrument you use to pay your Account. This includes any
            image of these instruments. When you provide an Item as payment, you
            authorize us either to use information from your Item to make a one
            time electronic fund transfer from your deposit account or to
            process the payment as a check transaction. When we use information
            from your Item to make an electronic funds transfer, funds may be
            withdrawn from your deposit account as soon as the same day your
            payment is received and you will not receive your Item back from
            your financial institution. You may contact us and ask that we not
            process your future Items in this way. If we process the payment as
            a check transaction, you understand and agree that we may convert
            your Item into an electronic image that can be collected from your
            depository institution as a substitute check. We will not be
            responsible if an Item you provide has physical features that, when
            imaged, result in it not being processed as you intended.
          </p>

          <h3>Items with Restrictive Words, Conditions or Instructions</h3>
          <p>
            All Items that have restrictive words, conditions, limitations or
            special instructions added (including Items marked with the words
            &ldquo;Paid in Full&rdquo; or similar language), and all
            accompanying communications, must be mailed to and received at: Card
            Services, STBL, 5513 W 11000 N #408, Highland UT 84003. If you make
            your payment or send any accompanying communications to any other
            address, we may accept and process the payment, without losing any
            of our rights.
          </p>

          <h3>Credit Balances</h3>
          <p>
            We may reject and return to you any portion of a payment that
            creates a credit balance on your Account. Any credit balance we
            allow will not be available to you until we confirm that the payment
            creating the credit balance has cleared. We may reduce the amount of
            any credit balance by any new amounts billed to your Account. You
            may contact us as provided on your Statement and request a refund of
            any available credit balance. If you contact us in writing, we will
            refund your credit balance within seven (7) business days from our
            receipt of your written request. A business day means any day in
            which our offices are open for the processing of Account payments
            and credits.
          </p>

          <h3>Account Default</h3>
          <p>We may consider you in default of your Agreement with us if:</p>
          <ul>
            <li>you do not make any payment when it is due;</li>
            <li>
              any payment you make is rejected, not paid or cannot be processed;
            </li>
            <li>you exceed a credit limit;</li>
            <li>
              a bankruptcy or other insolvency proceeding is filed by or against
              you;
            </li>
            <li>you die or are legally declared incompetent or incapacitated;</li>
            <li>
              we determine that you made a false, incomplete or misleading
              statement on any of your Account documentation, or you otherwise
              tried to defraud us;
            </li>
            <li>
              you do not comply with any term of this Agreement or any other
              agreement with us; or
            </li>
            <li>you permanently reside outside the United States.</li>
          </ul>
          <p>
            Paying the Interest Charges and Fees charged in connection with a
            default will not, by itself, cure the default. If you are in
            default, we may take the following actions without notifying you,
            after providing you with any notices that may be required by
            applicable law:
          </p>
          <ul>
            <li>close or suspend your Account;</li>
            <li>lower your credit limits;</li>
            <li>
              demand that you immediately pay the entire balance owing on your
              Account;
            </li>
            <li>
              continue to charge you Interest Charges and Fees as long as your
              balances remain outstanding; and/or
            </li>
            <li>
              pursue any other action against you that the law allows, which
              includes the filing of a lawsuit against you.
            </li>
          </ul>
          <p>
            You agree to pay us all of our collection expenses, attorneys&rsquo;
            fees, and court costs, unless the law does not allow us to collect
            these amounts.
          </p>

          <h3>Communications</h3>
          <p>
            By accepting these Card Terms or using your Card, you acknowledge
            that you have received, reviewed, and agree to be bound by the
            Issuer&rsquo;s E-Sign &amp; Electronic Communications Notice (the
            &ldquo;E-Sign Notice&rdquo;), which is incorporated herein by
            reference. You consent to receive all disclosures, notices,
            agreements, and other communications from Issuer and its service
            providers in electronic form, in accordance with the E-Sign Notice.
            You agree that such electronic communications satisfy any legal
            requirement that such communications be in writing. The E-Sign
            Notice may be amended by Issuer from time to time, and your
            continued use of the Card after any such amendment constitutes your
            acceptance of the amended E-Sign Notice.
          </p>
          <p>
            We may contact you from time to time about your Account. We may
            contact you in any manner we choose, unless the law says that we
            cannot. For example, we may:
          </p>
          <ul>
            <li>
              contact you by mail, telephone, email, fax, recorded message, text
              message or personal visit;
            </li>
            <li>
              contact you using an automated dialing or similar device
              (&ldquo;Autodialer&rdquo;);
            </li>
            <li>contact you at your home and at your place of employment;</li>
            <li>contact you on your mobile telephone;</li>
            <li>contact you at any time, including weekends and holidays;</li>
            <li>contact you with any frequency;</li>
            <li>
              leave recorded and other messages on your answering
              machine/service and with others; and
            </li>
            <li>
              identify ourselves, your relationship with us, and our purpose for
              contacting you, even if others might hear or read it.
            </li>
          </ul>
          <p>
            Our contacts with you about your Account are not unsolicited and may
            result from information we obtain from you or others. We may monitor
            or record any conversation or other communication with you. Unless
            the law prohibits us from doing so, we may modify or suppress caller
            identification and similar services and identify ourselves on these
            services in any manner we choose. When you give us or we obtain your
            mobile telephone number, we may contact you at this number using an
            Autodialer and can also leave recorded and other messages. We may do
            these things, whether we contact you or you contact us. If you ask
            us to discuss your Account with someone else, you must provide us
            with documents and authorization that we ask for and that are
            acceptable to us.
          </p>

          <h3>Credit Reports</h3>
          <p>
            We may provide information about you and the Account to consumer
            credit reporting agencies. We may also provide information about you
            and the Account to others as described in our Privacy Notices.
          </p>
          <p>
            We may report information about your account to credit bureaus. Late
            payments, missed payments, or other defaults on your account may be
            reflected in your credit report. We may obtain and use credit and
            income information about you from consumer credit reporting agencies
            and others as the law allows. If you believe we have reported
            inaccurate information about you to a credit reporting agency,
            notify us in writing at:
          </p>
          <div className={styles.addressBlock}>
            Card Services, STBL, 5513 W 11000 N #408, Highland UT 84003
          </div>
          <p>
            In doing so, identify yourself, your Account, the information you
            believe is inaccurate, and tell us why you believe the information
            is incorrect. If you have supporting documents or information, such
            as a copy of a credit report that includes information you believe
            is inaccurate, send us the supporting documents and information,
            too.
          </p>

          <h3>Closing or Suspending Your Account</h3>
          <p>
            You may ask us to close your Account by calling or writing us as
            described on your Statement. If you do, we may provide you with
            additional details about this process and request certain
            information from you, including payment information. If you use your
            Card or charges post to your Account after you ask us to close it,
            we may keep your Account open or reopen it. We may close or suspend
            your Account and your right to obtain credit from us. We may do this
            at any time and for any reason, as permitted by law, even if you are
            not in default. A suspension of your Account might be permanent or
            temporary.
          </p>
          <p>
            If your Account is closed or suspended for any reason, you must stop
            using your Card. You must also cancel all recurring charges or
            similar billing arrangements connected with the Account. We will not
            do this for you. If we close or permanently suspend your Account,
            you must also destroy all Cards.
          </p>
          <p>
            You must still pay us all amounts you owe on the Account, even if
            these amounts are charged after your Account is closed or suspended.
          </p>

          <h3>Additional Services</h3>
          <p>
            We may, from time to time, make additional services available to you
            directly or through affiliated or non-affiliated third parties.
            Without limitation, such services may include providing you with
            virtual accounts in order to enable you to use your Account or
            otherwise engage in various financial transactions that we do not
            directly provide. Each such service is subject to its own terms and
            conditions, and we shall not be responsible to you for any aspect of
            those services. We may permit you to charge any applicable fees for
            such services to your Account. You acknowledge and agree that we may
            receive compensation or otherwise benefit as a result of making such
            services available to you.
          </p>

          <h3>The Law that Applies to Your Agreement</h3>
          <p>
            This Agreement will be interpreted using Puerto Rican law. Federal
            law shall govern the Arbitration provisions of this Agreement, and
            as otherwise applicable. You waive any applicable statute of
            limitations, as the law allows. Otherwise, the applicable statute of
            limitations period for all provisions and purposes under this
            Agreement (including the right to collect debt) will be the longer of
            the time period provided by Puerto Rico law or the law of the
            jurisdiction where you live. If any part of this Agreement is found
            to be unenforceable, the remaining parts will remain in effect.
          </p>

          <h3>Waiver</h3>
          <p>
            We will not lose any of our rights if we delay taking any action for
            any reason or if we do not notify you. For example, we may waive
            your Interest Charges or Fees without notifying you and without
            losing our right to charge them in the future. We may always enforce
            our rights later and may take other actions not listed in this
            Agreement if the law allows them. You do not have to receive notice
            from us of any waiver, delay, demand or dishonor. We may proceed
            against you before proceeding against someone else.
          </p>

          <h3>Assignment</h3>
          <p>
            This Agreement will be binding on, and benefit, any of your and our
            successors and assigns. You may not transfer your Account or your
            Agreement to someone else without our written permission. We may
            transfer your Account, this Agreement, or any of our rights or
            obligations therein, to another company or person at any time,
            without your permission and without prior notice to you. If we do,
            they will take our place under this Agreement. You must pay them and
            perform all of your obligations to them and not us. If you pay us
            after you are informed or learn that we have transferred your
            Account or this Agreement, we can handle your payment in any way we
            think is reasonable. This includes returning the payment to you or
            forwarding the payment to the other company or person.
          </p>

          <h3>Dispute Resolution and Arbitration</h3>
          <div className={styles.importantNote}>
            <p>
              PLEASE READ THIS &ldquo;DISPUTE RESOLUTION AND ARBITRATION&rdquo;
              PROVISION VERY CAREFULLY. IT LIMITS YOUR RIGHTS IN THE EVENT OF A
              DISPUTE BETWEEN YOU AND ISSUER. STBL IS THE TECHNOLOGY PROVIDER
              FOR THE CARD BUT IS NOT THE ISSUER, CREDITOR OR LENDER. STBL IS
              NOT A PARTY TO THIS AGREEMENT AND HAS NO LIABILITY FOR THE
              ISSUER&rsquo;S OBLIGATIONS UNDER IT. HOWEVER, STBL IS AN EXPRESS
              THIRD-PARTY BENEFICIARY OF THIS AGREEMENT WITH RESPECT TO ANY
              PROVISIONS THAT ALLOCATE RISK, DISCLAIM LIABILITY, LIMIT REMEDIES
              OR REQUIRE DISPUTES TO BE RESOLVED THROUGH ARBITRATION.
              ACCORDINGLY, TO THE EXTENT A DISPUTE INVOLVES STBL, STBL SHALL BE
              ENTITLED TO INVOKE AND BENEFIT FROM THE SAME PROTECTIONS,
              LIMITATIONS AND DISPUTE RESOLUTION PROCEDURES AS THE ISSUER. TO
              THE EXTENT YOU HAVE ANY DISPUTE YOU MAY HAVE WITH STBL RELATING
              SOLELY TO SERVICES PROVIDED TO YOU UNDER YOUR SEPARATE USER TERMS
              WITH STBL, SUCH DISPUTES WILL BE GOVERNED EXCLUSIVELY IN
              ACCORDANCE WITH THE STBL USER TERMS.
            </p>
          </div>

          <h4>Binding Arbitration</h4>
          <p>
            (a) You and Issuer agree that any and all past, present and future
            Disputes (defined below) shall be determined by arbitration, unless
            your Dispute is subject to an exception to this agreement to
            arbitrate set forth below. You and Issuer further agree that any
            arbitration pursuant to this section shall not proceed as a class,
            group or representative action. The award of the arbitrator may be
            entered in any court having jurisdiction. &ldquo;Dispute&rdquo;
            means any dispute, claim, or controversy between you and Issuer that
            arises out of or relates to (i) this Agreement (including, without
            limitation, the Issuer Card, your Account, any addenda hereto or
            other terms incorporated herein by reference), (ii) the breach,
            termination, enforcement, interpretation or validity hereof,
            including the determination of the scope or applicability of the
            agreement to arbitrate hereunder, or (iii) any additional services
            we may provide to you in connection with this Agreement.
          </p>
          <p>
            (b) This agreement to arbitrate shall be construed under and be
            subject to the Federal Arbitration Act, notwithstanding any other
            choice of law set out in this Agreement.
          </p>
          <p>
            (c) The Binding Arbitration and Class Waiver sections of this
            Agreement does not apply to you if you are covered by the Military
            Lending Act nor do any provisions of the Agreement that waive any
            right to legal recourse under any state or federal law to the extent
            required by the Military Lending Act.
          </p>

          <h4>Arbitration Procedure</h4>
          <p>
            (a) Before filing a claim against Issuer, you agree to try to
            resolve the Dispute informally by providing written notice to Issuer
            of the actual or potential Dispute. Similarly, Issuer will provide
            written notice to you of any actual or potential Dispute to endeavor
            to resolve any claim we may possess informally before taking any
            formal action. The party that provides the notice of the actual or
            potential Dispute (the &ldquo;Notifying Party&rdquo;) will include
            in that notice (a &ldquo;Notice of Dispute&rdquo;) the name of
            Company, the Notifying Party&rsquo;s contact information for any
            communications relating to such Dispute, and sufficient details
            regarding such Dispute to enable the other party (the
            &ldquo;Notified Party&rdquo;) to understand the basis of and
            evaluate the concerns raised. If the Notified Party responds within
            ten (10) business days after receiving the Notice of Dispute that it
            is ready and willing to engage in good faith discussions in an
            effort to resolve the Dispute informally, then each party shall
            promptly participate in such discussions in good faith.
          </p>
          <p>
            (b) If, notwithstanding the Notifying Party&rsquo;s compliance with
            all of its obligations under the preceding paragraph, a Dispute is
            not resolved within thirty (30) days after the Notice of Dispute is
            sent (or if the Notified Party fails to respond to the Notice of
            Dispute within ten (10) business days), the Notifying Party may
            initiate an arbitration proceeding as described below. If either
            party purports to initiate arbitration without first providing a
            Notice of Dispute and otherwise complying with all of its
            obligations under the preceding paragraph, then, notwithstanding any
            other provision of this Card Agreement, the arbitrator(s) will
            promptly dismiss the claim with prejudice and will award the other
            party all of its costs and expenses (including, without limitation,
            reasonable attorneys&rsquo; fees) incurred in connection with such
            Dispute.
          </p>
          <p>
            (c) You and Issuer each agree to resolve any Disputes that are not
            resolved informally as described above through final and binding
            arbitration as discussed herein, except as set forth under
            &ldquo;Small Claims&rdquo; below. You and Issuer agree that the
            American Arbitration Association (&ldquo;AAA&rdquo;) will administer
            the arbitration under its Consumer Arbitration Rules (the
            &ldquo;Rules&rdquo;). The Rules are available at{" "}
            <a
              href="https://www.adr.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.adr.org
            </a>{" "}
            or by calling the AAA at 1-800-778-7879. A party who desires to
            initiate arbitration must provide the other party with a written
            Demand for Arbitration as specified in the AAA Rules. (The AAA
            provides a general Demand for Arbitration.) Arbitration will proceed
            on an individual basis and will be handled by a sole arbitrator. The
            single arbitrator will be either a retired judge or an attorney
            licensed to practice law and will be selected by the parties from
            the AAA&rsquo;s roster of arbitrators. If the parties are unable to
            agree upon an arbitrator within fourteen (14) days of delivery of
            the Demand for Arbitration, then the AAA will appoint the arbitrator
            in accordance with the AAA Rules. The arbitrator(s) shall be
            authorized to award any remedies, including injunctive relief, that
            would be available to you in an individual lawsuit, subject to any
            effective and enforceable limitations of liability or exclusions of
            remedies set forth herein. Notwithstanding any language to the
            contrary in this paragraph, if a party seeks injunctive relief that
            would significantly impact other Issuer users as reasonably
            determined by either party, the parties agree that such arbitration
            will proceed on an individual basis but will be handled by a panel
            of three (3) arbitrators. Each party shall select one arbitrator,
            and the two party-selected arbitrators shall select the third, who
            shall serve as chair of the arbitral panel. That chairperson shall
            be a retired judge or an attorney licensed to practice law and with
            experience arbitrating or mediating disputes. In the event of
            disagreement as to whether the threshold for a three-arbitrator
            panel has been met, the sole arbitrator appointed in accordance with
            this Section shall make that determination. If the arbitrator
            determines a three-person panel is appropriate, the arbitrator may
            -- if selected by either party or as the chair by the two
            party-selected arbitrators -- participate in the arbitral panel.
            Except as and to the extent otherwise may be required by law, the
            arbitration proceeding and any award shall be confidential.
          </p>
          <p>
            (d) You and Issuer further agree that the arbitration will be held
            in the English language in New York, New York, or, if you so elect,
            all proceedings can be conducted via videoconference, telephonically
            or via other remote electronic means.
          </p>
          <p>
            (e) Filing costs and administrative fees shall be paid in accordance
            with the AAA Rules; provided that the prevailing party will be
            entitled to recover its reasonable attorneys&rsquo; fees, expert
            witness fees, and out-of-pocket costs incurred in connection with
            the arbitration proceeding, in addition to any other relief it may
            be awarded.
          </p>
          <p>
            (f) You and Issuer agree that, notwithstanding anything to the
            contrary in the Rules, the arbitration of any Dispute shall proceed
            on an individual basis, and neither you nor Issuer may bring a claim
            as a part of a class, group, collective, coordinated, consolidated
            or mass arbitration (each, a &ldquo;Collective Arbitration&rdquo;).
            Without limiting the generality of the foregoing, a claim to resolve
            any Dispute against Issuer will be deemed a Collective Arbitration
            if (i) two (2) or more similar claims for arbitration are filed
            concurrently by or on behalf of one or more claimants; and (ii)
            counsel for the claimants are the same, share fees or coordinate
            across the arbitrations. &ldquo;Concurrently&rdquo; for purposes of
            this provision means that both arbitrations are pending (filed but
            not yet resolved) at the same time.
          </p>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU NOR ISSUER
            SHALL BE ENTITLED TO CONSOLIDATE, JOIN OR COORDINATE DISPUTES BY OR
            AGAINST OTHER INDIVIDUALS OR ENTITIES, OR ARBITRATE OR LITIGATE ANY
            DISPUTE IN A REPRESENTATIVE CAPACITY, INCLUDING AS A REPRESENTATIVE
            MEMBER OF A CLASS OR IN A PRIVATE ATTORNEY GENERAL CAPACITY. IN
            CONNECTION WITH ANY DISPUTE, ANY AND ALL SUCH RIGHTS ARE HEREBY
            EXPRESSLY AND UNCONDITIONALLY WAIVED. Without limiting the
            foregoing, any challenge to the validity of this paragraph shall be
            determined exclusively by the arbitrator.
          </p>

          <h4>Small Claims</h4>
          <p>
            Notwithstanding your and Issuer&rsquo;s agreement to arbitrate
            Disputes, You and Issuer retain the right to bring an individual
            action in small claims court.
          </p>

          <h4>Class Waiver</h4>
          <p>
            To the extent applicable law permits, any dispute arising out of or
            relating to this Card Agreement, whether in arbitration or in court,
            will be conducted only on an individual basis and not in a class,
            consolidated or representative action. Notwithstanding any other
            provision of this Agreement or the AAA Rules, disputes regarding the
            interpretation, applicability, or enforceability of this class
            waiver may be resolved only by a court and not by an arbitrator. If
            this waiver of class or consolidated actions is deemed invalid or
            unenforceable, neither party is entitled to arbitration.
          </p>

          <h4>No Jury Trial</h4>
          <p>
            If for any reason a claim or dispute proceeds in court rather than
            through arbitration, each party knowingly and irrevocably waives any
            right to trial by jury in any action, proceeding or counterclaim
            arising out of or relating to this Card Agreement.
          </p>

          <h4>Venue and Jurisdiction for Judicial Proceedings</h4>
          <p>
            Except as otherwise required by applicable law or provided in this
            Card Agreement, in the event that the agreement to arbitrate is
            found not to apply to you or your Dispute, you and Issuer agree that
            any judicial proceeding may only be brought in a court of competent
            jurisdiction in Puerto Rico. Both you and Issuer irrevocably consent
            to venue and personal jurisdiction there; provided that either party
            may bring any action to confirm an arbitral award in any court
            having jurisdiction.
          </p>

          <h4>Confidentiality</h4>
          <p>
            The existence of and all information regarding any Dispute will be
            held in strict confidence by the parties and will not be disclosed
            by either party except as reasonably necessary in connection with
            the conduct of the arbitration or the confirmation or enforcement of
            any arbitral award. Any such permitted disclosure will, to the
            maximum extent reasonably practicable, be made subject to
            obligations of confidentiality at least as stringent as the
            provisions of this paragraph. If any disclosure of information
            regarding any Dispute is required under applicable law, the parties
            shall reasonably cooperate with one another to obtain protective
            orders or otherwise to preserve the confidentiality of such
            information.
          </p>

          <h3>Survival</h3>
          <p>
            The following provisions of this Agreement shall survive any
            termination or expiration of this Agreement and shall remain in full
            force and effect until all of your obligations to us have been fully
            and finally satisfied: (a) all of your payment obligations and our
            right to collect all amounts owed by you; (b) all security interest,
            collateral, and setoff provisions, including our rights in any
            Collateral; (c) any indemnification obligations; (d) the limitation
            of liability provisions; (e) the disclaimer of warranties
            provisions; (f) the dispute resolution and arbitration provisions,
            including the class waiver; (g) our communications and contact
            rights; (h) our credit reporting rights and your consent thereto;
            (i) the governing law and jurisdiction provisions; (j) our
            assignment rights; (k) any waiver provisions; (l) all
            representations and warranties made by you; (m) any accrued rights,
            remedies, or causes of action in favor of either party; and (n) any
            other provision that by its nature or express terms is intended to
            survive.
          </p>

          <h3>Severability</h3>
          <p>
            If any provision of this Agreement is found to be invalid, illegal,
            or unenforceable by a court or arbitrator of competent jurisdiction,
            such provision shall be modified to the minimum extent necessary to
            make it valid and enforceable while preserving its intent, or if
            such modification is not possible, such provision shall be severed
            from this Agreement. The remaining provisions shall remain in full
            force and effect.
          </p>
          <p>
            Notwithstanding the foregoing paragraph, in the event that a court
            finds the prohibition of Collective Arbitration under the Dispute
            Resolution and Arbitration Section to be invalid or unenforceable,
            then all provisions related to arbitration in that section shall be
            deemed void, except for any portion of any provision in that section
            related to the resolution of Disputes through litigation in court.
          </p>

          <h3>Entire Agreement</h3>
          <p>
            This Agreement constitutes the entire agreement between you and
            Issuer regarding the subject matter hereof and supersede all prior
            or contemporaneous agreements, understandings, representations, and
            communications whether written or oral, regarding such subject
            matter.
          </p>

          <h3>Limitation of Liability</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            ISSUER, ITS AFFILIATES, OR ITS OFFICERS, DIRECTORS, EMPLOYEES,
            AGENTS, SERVICE PROVIDERS, OR LICENSORS BE LIABLE TO YOU FOR ANY
            INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE,
            OR OTHER SIMILAR DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS,
            LOST REVENUE, LOST DATA, LOSS OF GOODWILL, BUSINESS INTERRUPTION, OR
            LOSS OF BUSINESS OPPORTUNITY, WHETHER ARISING IN CONTRACT, TORT,
            NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE, EVEN IF ISSUER HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p>
            IN NO EVENT SHALL ISSUER&rsquo;S TOTAL LIABILITY TO YOU FOR ALL
            CLAIMS ARISING OUT OF OR RELATING TO THIS AGREEMENT OR YOUR ACCOUNT
            EXCEED THE LESSER OF (A) YOUR ACTUAL DIRECT DAMAGES PROVEN OR (B)
            THE TOTAL AMOUNTS PAID BY YOU IN CONNECTION WITH THIS AGREEMENT IN
            THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE EVENT GIVING RISE
            TO THE CLAIM.
          </p>

          <h3>Indemnity</h3>
          <p>
            You will indemnify and defend Issuer, its affiliates, and its
            partners, directors, officers, employees, agents, trustees,
            administrators, managers, advisors, and representatives (each an
            &ldquo;Indemnitee&rdquo;) against, and hold each Indemnitee harmless
            from, any and all claims, litigation, investigations, proceedings,
            losses, damages, fines, penalties, liabilities, settlements, costs,
            fees, and expenses incurred by any Indemnitee or asserted against
            any Indemnitee by any person arising out of, in connection with,
            related to, or as a result of your (i) breach of any of the
            representations, warranties, or covenants contained in this
            Agreement; or (ii) gross negligence, fraud, or violation of any
            applicable law or rights of any third-party. Issuer may defend any
            claim subject to indemnification hereunder, using counsel of its
            choice, and you will pay or promptly reimburse Issuer for the
            reasonable fees of such counsel and all related costs and reasonable
            expenses. If you are a user from a jurisdiction that does not allow
            certain indemnification obligations, you agree that this indemnity
            is intended to be as broad as permitted under the laws of such
            jurisdiction.
          </p>

          <h3>Your Billing Rights: Keep This Document For Future Use</h3>
          <p>
            This notice is for Consumers using the Card Account and tells you
            about your rights and our responsibilities under the Fair Credit
            Billing Act.
          </p>

          <h4>What To Do If You Find A Mistake On Your Statement</h4>
          <p>
            If you think there is an error on your statement, write to us at:
          </p>
          <div className={styles.addressBlock}>
            Card Services
            <br />
            STBL
            <br />
            5513 W 11000 N #408, Highland UT 84003
          </div>
          <p>In your letter, give us the following information:</p>
          <ul>
            <li>
              Account information: Your name and account number.
            </li>
            <li>
              Dollar amount: The dollar amount of the suspected error.
            </li>
            <li>
              Description of problem: If you think there is an error on your
              bill, describe what you believe is wrong and why you believe it is
              a mistake.
            </li>
          </ul>
          <p>You must contact us:</p>
          <ul>
            <li>Within 60 days after the error appeared on your statement.</li>
            <li>
              At least 3 business days before an automated payment is scheduled,
              if you want to stop payment on the amount you think is wrong.
            </li>
          </ul>
          <p>
            You must notify us of any potential errors in writing. You may call
            us or notify us electronically, but if you do we are not required to
            investigate any potential errors and you may have to pay the amount
            in question.
          </p>

          <h4>What Will Happen After We Receive Your Letter</h4>
          <p>When we receive your letter, we must do two things:</p>
          <ul>
            <li>
              Within 30 days of receiving your letter, we must tell you that we
              received your letter. We will also tell you if we have already
              corrected the error.
            </li>
            <li>
              Within 90 days of receiving your letter, we must either correct
              the error or explain to you why we believe the bill is correct.
            </li>
          </ul>
          <p>While we investigate whether or not there has been an error:</p>
          <ul>
            <li>
              We cannot try to collect the amount in question, or report you as
              delinquent on that amount.
            </li>
            <li>
              The charge in question may remain on your statement, and we may
              continue to charge you interest on that amount.
            </li>
            <li>
              While you do not have to pay the amount in question, you are
              responsible for the remainder of your balance.
            </li>
            <li>
              We can apply any unpaid amount against your credit limit (where
              applicable).
            </li>
          </ul>
          <p>
            After we finish our investigation, one of two things will happen:
          </p>
          <ul>
            <li>
              If we made a mistake: You will not have to pay the amount in
              question or any interest or other fees related to that amount.
            </li>
            <li>
              If we do not believe there was a mistake: You will have to pay the
              amount in question, along with applicable interest and fees. We
              will send you a statement of the amount you owe and the date
              payment is due. We may then report you as delinquent if you do not
              pay the amount we think you owe.
            </li>
          </ul>
          <p>
            If you receive our explanation but still believe your bill is wrong,
            you must write to us within 10 days telling us that you still refuse
            to pay. If you do so, we cannot report you as delinquent without
            also reporting that you are questioning your bill. We must tell you
            the name of anyone to whom we reported you as delinquent, and we
            must let those organizations know when the matter has been settled
            between us.
          </p>
          <p>
            If we do not follow all of the rules above, you do not have to pay
            the first $50 of the amount you question even if your bill is
            correct.
          </p>

          <h4>
            Your Rights If You Are Dissatisfied With Your Credit Card Purchases
          </h4>
          <p>
            If you are dissatisfied with the goods or services that you have
            purchased with your credit card, and you have tried in good faith to
            correct the problem with the merchant, you may have the right not to
            pay the remaining amount due on the purchase.
          </p>
          <p>To use this right, all of the following must be true:</p>
          <ul>
            <li>
              The purchase must have been made in your home state or within 100
              miles of your current mailing address, and the purchase price must
              have been more than $50. (Note: Neither of these are necessary if
              your purchase was based on an advertisement we mailed to you, or
              if we own the company that sold you the goods or services.)
            </li>
            <li>
              You must have used your credit card for the purchase. Purchases
              made with cash advances from an ATM do not qualify.
            </li>
            <li>You must not yet have fully paid for the purchase.</li>
          </ul>
          <p>
            If all of the criteria above are met and you are still dissatisfied
            with the purchase, contact us in writing at:
          </p>
          <div className={styles.addressBlock}>
            Card Services
            <br />
            STBL
            <br />
            5513 W 11000 N #408, Highland UT 84003
          </div>
          <p>
            While we investigate, the same rules apply to the disputed amount as
            discussed above. After we finish our investigation, we will tell you
            our decision. At that point, if we think you owe an amount and you
            do not pay, we may report you as delinquent.
          </p>

          <h3>Additional Disclosures for Residents of Certain States</h3>
          <h4>Maryland Residents:</h4>
          <ul>
            <li>
              This Agreement is governed by the Credit Grantor Revolving Credit
              Provisions in Subtitle 9 of Title 12 (Credit Regulations) of the
              Maryland Commercial Law, Md. Commercial Law Code Ann. § 12-901,
              et. seq.
            </li>
            <li>
              Upon your default pursuant to the terms of this Agreement, we may
              recover from you our attorneys&rsquo; fees and all court or other
              collection costs actually incurred by us in connection with your
              default.
            </li>
            <li>You acknowledge that you received a copy of this Agreement.</li>
          </ul>
          <p>
            <strong>South Dakota Residents:</strong> Any improprieties regarding
            this loan or our lending practices may be referred to the South
            Dakota Division of Banking at: Division of Banking, South Dakota
            Department of Labor and Regulation, 1714 Lincoln Ave., Suite 2,
            Pierre, SD 57501. Phone: 605.773.3421.
          </p>
          <h4>Wisconsin Residents:</h4>
          <ul>
            <li>
              Notwithstanding anything to the contrary in this Agreement, we
              will not be entitled to recover our attorneys&rsquo; fees from you
              upon default.
            </li>
            <li>
              Notwithstanding anything to the contrary in this Agreement, this
              Agreement shall be governed by Wisconsin law and any legal action
              that we bring against you, if any, will be in Wisconsin.
            </li>
            <li>
              By accepting this Agreement, you are certifying that this Account
              is being incurred by you in the interest of your marriage or
              family.
            </li>
            <li>
              No provision of any marital property agreement (including any
              premarital agreement), unilateral statement under §766.59 of the
              Wisconsin Statutes, or court decree under §766.70 of the Wisconsin
              Statutes adversely affects our interest unless we, prior to the
              time that the loan is approved, are furnished with a copy of the
              marital property agreement, a statement, or a decree or have
              actual knowledge of the adverse provision.
            </li>
            <li>
              You must notify us if you have a spouse and provide us with their
              name and address so that we can provide a copy of this Agreement
              or otherwise notify your spouse of this Account.
            </li>
            <li>
              Your spouse may terminate the Account by requesting termination in
              writing, in which case we may require you to pay the entire amount
              due to us immediately. Termination of the Account by your spouse
              does not reduce or remove any of your liability to us in
              connection with the Account.
            </li>
          </ul>
        </section>
      </div>
    </LegalLayout>
  );
};

export default CardTermsUS;
